import { useQuery } from "@tanstack/vue-query";
import { BookingOrdersApi, ItinerariesApi } from "@xs2event/js-lib/api";
import { computed, unref, type MaybeRef } from "vue";

const itinerariesApi = new ItinerariesApi();
const bookingordersApi = new BookingOrdersApi();

export const useItineraries = (items: MaybeRef<{ bookingorderId: string; ticketId: string }[]>) => {
  const query = useQuery({
    queryKey: computed(() => ["itineraries", unref(items)]),
    queryFn: async () => {
      const _items = unref(items);

      const itineraries = await Promise.all(
        _items.map(async (item) => ({ ...item, ...(await itinerariesApi.itineraryshareGet(item)) }))
      );

      return itineraries;
    },
  });

  const isLoading = computed(() => query.isFetching.value);

  const openItineraries = () => {
    bookingordersApi.bookingitinerarysharelinkPost(validItineraries.value[0]).then((response) => {
      window.open(response.itineraryLink, "_blank");
    });
  };

  const validItineraries = computed(() => {
    return (
      query.data.value?.filter((itinerary) => {
        if (
          !itinerary.colors?.primaryColorCode ||
          !itinerary.colors?.secondaryColorCode ||
          !itinerary.colors?.ternaryColorCode
        ) {
          return false;
        }

        if (!itinerary.gettingThere || Object.values(itinerary.gettingThere).some((value) => !value)) {
          return false;
        }

        return true;
      }) || []
    );
  });

  const { data: itineraries } = query;

  return { isLoading, itineraries, openItineraries, validItineraries };
};
